/** Preserves the original PWA prompt markup and selectors. */
export function InstallPrompt() {
  return (
    <div className="installchip" id="installChip">
      <button className="icobody">
        <span className="icoicon">📲</span>
        <span className="icotxt"><b>Install Quran Club</b><small>Own it on your home screen — no app store needed</small></span>
        <span className="icoarrow">›</span>
      </button>
      <button className="icoclose" aria-label="Dismiss">✕</button>
    </div>
  );
}
